import React from 'react';

interface ListProps {
  isLoading: boolean;
  title: string;
  onSubmitCallback: () => void;
  children: React.ReactNode;
}

export default function Form({
  isLoading,
  title,
  onSubmitCallback,
  children,
}: ListProps) {
  return (
    <>
      <header className={isLoading ? 'placeholder-wave' : ''}>
        <h1>
          <span className={isLoading ? 'placeholder' : ''}>{title}</span>
        </h1>
      </header>

      <main className='mt-3'>
        {isLoading ? (
          <div className='placeholder-glow'>
            <span className='placeholder placeholder-lg col-12' />
            <span className='placeholder placeholder-xs col-12 bg-dark' />
            <span className='placeholder col-12 bg-secondary' />
          </div>
        ) : (
          <div>{children}</div>
        )}
      </main>
    </>
  );
}
